import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { requestNavigation } from '@xanadu/ui-shared/modules/navigation/actions';

import Navigation from '../../../components/navigation/Navigation';
import { EMPTY_LIST } from '../../../constants';

const EMPTY_ARRAY = [];

const mapDispatchToProps = {
  requestNavigation
};

function mapStateToProps(state) {
  return {
    product: state.getIn(['application', 'product']),
    pendingUIUpdate: state.getIn(['application', 'pendingUIUpdate']),
    casinoLobbies: state.getIn(['vegas', 'lobbies', 'classic-casino', 'data']),
    liveCasinoLobbies: state.getIn(['vegas', 'lobbies', 'live-casino', 'data']),
    virtualLobbies: state.getIn(['vegas', 'lobbies', 'virtual-sports', 'data']),
    widthSize: state.getIn(['application', 'widthSize']),
    uiVersion: state.getIn(['application', 'uiVersion']),
    topPosition: state.getIn(['application', 'topPosition']),
    loading: state.getIn(['navigation', 'loading']),
    tags: state.getIn(['navigation', 'tags'], EMPTY_ARRAY),
    topFive: state.getIn(['navigation', 'topFive'], EMPTY_ARRAY),
    virtualsAllowed: state.getIn(['user', 'virtualsAllowed']),
    cinemaMode: state.getIn(['application', 'cinemaMode']),
    casinoVisibilityRestricted: state.getIn(['vegas', 'visibilityRestricted']),
    inPlayTags: state.getIn(['navigation', 'inPlayTags'], EMPTY_LIST),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Navigation));
